<template>
  <svg
    class="svg-icon loading-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="background: rgba(224, 102, 102, 0); display: block;"
    width="250px"
    height="250px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke="#fff"
      stroke-width="14"
      r="40"
      stroke-dasharray="188.49555921538757 64.83185307179586"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="0.6s"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
      ></animateTransform>
    </circle>
  </svg>
</template>

<script>
export default {
  name: "LoadingIcon"
};
</script>

<style lang="scss" scoped>
.loading-icon {
  circle {
    stroke: currentColor;
  }
}
</style>
